export default __webpack_public_path__ + "static/media/loading.bf695f31.svg";